$(document).ready(function () {
    var searchTime;
    var searchRequest;
    var autocompleteRequestId = 0;

    function closeAutocomplete(cancelRequest) {
        if (cancelRequest) {
            autocompleteRequestId++;
            if (searchRequest && searchRequest.readyState !== 4) {
                searchRequest.abort();
            }
            searchRequest = null;
        }
        $('.AXsearch_content').empty();
        $('#JSsearch2').attr('aria-expanded', 'false');
    }

    function timer2() {
        var search = String($('#JSsearch2').val() || '').trim();
        var requestId = ++autocompleteRequestId;

        // V2 accepts two real characters.  Keeping this in sync with the
        // endpoint avoids needless requests while still handling short SKUs.
        if (search.length < 2) {
            if (searchRequest && searchRequest.readyState !== 4) {
                searchRequest.abort();
            }
            searchRequest = null;
            closeAutocomplete(false);
            return;
        }

        if (searchRequest && searchRequest.readyState !== 4) {
            searchRequest.abort();
        }

        searchRequest = $.post(base_url + 'ajax-search', {search: search})
            .done(function (response) {
                // Aborting is not enough on every browser/network path; only
                // the newest response may touch the visible autocomplete.
                if (requestId !== autocompleteRequestId) {
                    return;
                }
                if (response !== '') {
                    $('.JSsearch_list').remove();
                    $('.AXsearch_content').html(response);
                    $('#JSsearch2').attr('aria-expanded', 'true');
                } else {
                    closeAutocomplete(false);
                }
            })
            .always(function (_, status) {
                if (requestId === autocompleteRequestId && status !== 'abort') {
                    searchRequest = null;
                }
            });
    }

    function queueAutocomplete() {
        clearTimeout(searchTime);
        searchTime = setTimeout(timer2, 220);
    }

    $(document).on('input', '#JSsearch2', queueAutocomplete);

    $('.JSSearchGroup2').change(function () {
        queueAutocomplete();
    });

    $(document).on('keydown', '#JSsearch2', function (event) {
        var items = $('.AXsearch_content .JSsearch-v2-autocomplete-option');
        if (!items.length) {
            if (event.key === 'Escape') {
                closeAutocomplete(true);
            }
            return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            var current = items.index(document.activeElement);
            var next = event.key === 'ArrowDown'
                ? Math.min(items.length - 1, current + 1)
                : Math.max(0, current < 0 ? 0 : current - 1);
            items.eq(next).trigger('focus');
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            closeAutocomplete(true);
        }
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.JSsearchContent2').length) {
            $('.JSsearch_list').remove();
            closeAutocomplete(true);
        }
    });
});

$(document).on('click', '.JSrecommendation-track', function (event) {
    if (event.which === 2 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
    var link = $(this);
    var productId = link.data('roba-id');
    if (!productId) { return; }

    event.preventDefault();
    var destination = link.attr('href');
    $.post(base_url + 'recommendations/track', { event_type: 'recommendation_click', roba_id: productId })
        .always(function () { window.location.assign(destination); });
});

$(document).on('click', '.JSsearch-v2-autocomplete-track', function (event) {
    if (event.which === 2 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
    var link = $(this);
    var productId = link.data('roba-id');
    var query = link.closest('.search-v2-autocomplete').data('search-v2-query');
    if (!productId || !query) { return; }

    event.preventDefault();
    var destination = link.attr('href');
    $.post(base_url + 'search-v2/autocomplete-click', { search: query, roba_id: productId })
        .always(function () { window.location.assign(destination); });
});
